import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import { SwitchPackageStageName } from "app/custom-hooks/switchPackage/useSubmitPackageChange.types";

import { StageFailureDescription, StageFailureIcon } from "./components/StageFailure/StageFailure";
import { StageLoading } from "./components/StageLoading/StageLoading";
import {
    StagePaymentFailureDescription,
    StagePaymentFailureIcon,
} from "./components/StagePaymentFailure/StagePaymentFailure";
import { StageSuccessDescription, StageSuccessIcon } from "./components/StageSuccess/StageSuccess";

export interface ISwitchPackageStageData {
    title: string;
    isCloseButtonAvailable: boolean;
    showActionButtons: boolean;
    icon: React.ReactElement;
    stage: SwitchPackageStageName;
    description?: React.ReactElement;
    trackingEventName?: string;
}

export const getSwitchPackageStageData = (
    switchPackageStageName: SwitchPackageStageName | null,
    onSwitchPackageFailure: () => void,
    targetProductName?: string,
): ISwitchPackageStageData => {
    const loadingState: ISwitchPackageStageData = {
        title: "subscription.info.nt.switch.loader.title",
        isCloseButtonAvailable: false,
        stage: SwitchPackageStageName.LOADING,
        showActionButtons: false,
        icon: <StageLoading />,
    };

    switch (switchPackageStageName) {
        case SwitchPackageStageName.LOADING: {
            return loadingState;
        }
        case SwitchPackageStageName.SUCCESS: {
            return {
                title: "",
                stage: SwitchPackageStageName.SUCCESS,
                isCloseButtonAvailable: false,
                showActionButtons: true,
                trackingEventName: "payment success change popup",
                icon: <StageSuccessIcon />,
                description: <StageSuccessDescription />,
            };
        }
        case SwitchPackageStageName.FAILURE: {
            return {
                title: "subscription.info.nt.change.plan.failure.title",
                isCloseButtonAvailable: true,
                stage: SwitchPackageStageName.FAILURE,
                showActionButtons: false,
                trackingEventName: "payment failure change popup",
                icon: <StageFailureIcon />,
                description: <StageFailureDescription onContactClick={onSwitchPackageFailure} />,
            };
        }
        case SwitchPackageStageName.PAYMENT_FAILURE: {
            return {
                title: NO_TOUCH_PURCHASE_TRANSLATIONS.paymentFailure.title,
                isCloseButtonAvailable: true,
                stage: SwitchPackageStageName.PAYMENT_FAILURE,
                showActionButtons: false,
                trackingEventName: "payment failure change popup",
                icon: <StagePaymentFailureIcon />,
                description: <StagePaymentFailureDescription targetProductName={targetProductName} />,
            };
        }
        default: {
            return loadingState;
        }
    }
};
